//HEADER SEARCH BLOCK START 
{

  document.querySelector('#header-search .remove-search')?.addEventListener('click', function () {
    this.closest('details').open = false;
  });
  const headerSearch = document.querySelector('#header-search');
  const search = headerSearch.querySelector('.search');
  const form = headerSearch.querySelector('.search__form');
  const input = form.querySelector('.search-query');
  const searchType = form.querySelector('input[name="type"]').value;
  const resultsContainer = headerSearch.querySelector('.search__results-container');
  const resultsList = headerSearch.querySelector('.search__results-list');
  const resultsOuter = headerSearch.querySelector('.search-outer');
  const resultsScroller = headerSearch.querySelector('.search__results-scroller');
  let searchRequest;

  function removePagination() {
    const pagination = resultsContainer.querySelector('.pagination');

    if (pagination) {
      pagination.remove();
    }
  }

  function clearSearch() {
    search.classList.remove('search--loading', 'search--loaded');
    resultsList.replaceChildren();
    resultsOuter.replaceChildren();
    removePagination();
  }

  function renderSearchResults(html) {
    const page = new DOMParser().parseFromString(html, 'text/html');
    const products = page.querySelectorAll('.product-item');
    const resultsText = page.querySelector('.search-results-text');
    const pagination = page.querySelector('.pagination');

    resultsList.replaceChildren(...products);
    resultsOuter.replaceChildren(resultsText);
    removePagination();

    if (pagination) {
      resultsContainer.append(pagination);
    }
  }

  async function requestSearch(query) {
    search.classList.add('search--loading');
    resultsList.replaceChildren();
    removePagination();

    if (searchRequest) {
      searchRequest.abort();
    }

    searchRequest = new AbortController();

    const params = new URLSearchParams({
      q: query,
      type: searchType,
    });

    const response = await fetch(`/search?${params}`, {
      signal: searchRequest.signal,
    });

    const html = await response.text();

    renderSearchResults(html);
    search.classList.remove('search--loading');
    search.classList.add('search--loaded');
  }

  async function loadMoreSearchResults(url) {
    search.classList.remove('search--loaded');
    search.classList.add('search--loading');

    const response = await fetch(url);
    const html = await response.text();
    const page = new DOMParser().parseFromString(html, 'text/html');
    const products = page.querySelectorAll('.product-item');
    const nextPage = page.querySelector('.js-loadMore');
    const pagination = resultsContainer.querySelector('.pagination');

    resultsList.append(...products);
    pagination.replaceChildren();

    if (nextPage) {
      pagination.append(nextPage);
    }

    search.classList.remove('search--loading');
    search.classList.add('search--loaded');
  }

  form?.addEventListener('submit', (event) => {
    if (input.value.trim() === '') {
      event.preventDefault();
    }
  });

  input?.addEventListener('keyup', async () => {
    const query = input.value.trim();

    if (query.length === 0) {
      clearSearch();
      return;
    }

    try {
      await requestSearch(query);
    } catch (error) {
      if (error.name !== 'AbortError') {
        throw error;
      }
    }
  });

  resultsContainer?.addEventListener('click', (event) => {
    const loadMore = event.target.closest('.js-loadMore');

    if (!loadMore) {
      return;
    }

    event.preventDefault();
    loadMoreSearchResults(loadMore.href);
  });

  resultsScroller?.addEventListener('scroll', () => {
    const pagination = resultsContainer.querySelector('.pagination');

    if (!pagination || search.classList.contains('search--loading')) {
      return;
    }

    const scrollTriggerPoint = resultsContainer.offsetHeight - resultsScroller.offsetHeight * 2;

    if (resultsScroller.scrollTop >= scrollTriggerPoint) {
      const loadMore = pagination.querySelector('.js-loadMore');

      if (loadMore) {
        loadMore.click();
      }
    }
  });
}
//HEADER SEARCH BLOCK END 



{
  const collectionLoop = document.querySelector('#CollectionLoop');
  const collectionPagination = document.querySelector('#CollectionPagination');

  if (collectionLoop && collectionPagination) {
    const observer = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }

      const nextPage = collectionPagination.querySelector('a');

      if (!nextPage) {
        observer.disconnect();
        return;
      }

      observer.unobserve(collectionPagination);
      collectionPagination.innerHTML = '<div class="loader"><div class="loader-indeterminate"></div></div>';

      const response = await fetch(nextPage.href);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextCollectionLoop = page.querySelector('#CollectionLoop');
      const nextCollectionPagination = page.querySelector('#CollectionPagination');

      collectionLoop.append(...nextCollectionLoop.children);
      collectionPagination.innerHTML = nextCollectionPagination.innerHTML;
      window.dispatchEvent(new Event('scroll'));

      observer.observe(collectionPagination);
    });

    observer.observe(collectionPagination);
  }
}

//Add Product From Product Grid
document.querySelectorAll('.product-grid')?.forEach(grid_item=>{
  grid_item.addEventListener('click', (event) => {
    const item = event.target.closest('.product-grid .shopnow');
    if (!item) {
      return;
    }
    event.preventDefault();
    let form = item.closest('form');
    let data = Object.fromEntries(new FormData(form));
    cartDrawer.state_change(data, 'add');
    cartDrawer.open();
  });
})





document.querySelector('.collection-shop-subscriptions')?.addEventListener('change', (event)=>{
  const item = event.target.closest('select[name="selling_plan"]');
  if (!item) {
    return;
  }
  let product_link = item.closest('a');
  let product_url = new URL(product_link.href);
  product_url.searchParams.set('selling_plan', item.value);
  product_link.href = product_url.toString();
})



//Update Cart Counter when something changes in the cart
document.addEventListener('cart-updated',(e)=>{
  let new_cart_counter_value = e.detail.counter == 0 ? '' : e.detail.counter;
  document.querySelector('.header__cart__count').innerHTML = new_cart_counter_value;
});